import * as React from 'react';
import * as PropTypes from 'prop-types';
import Toolbar from '@material-ui/core/Toolbar';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  emptyMessage: {
    margin: '0 auto',
    padding: `${theme.spacing.unit * 5}px 0`,
    fontFamily: theme.typography.fontFamily,
    color: theme.typography.subtitle1.color,
    fontSize: theme.typography.subtitle1.fontSize,
  },
});

export const EmptyMessageBase = ({
  getMessage,
  classes,
  ...restProps
}) => (
  <Toolbar
    {...restProps}
  >
    <big className={classes.emptyMessage}>
      {getMessage('noColumns')}
    </big>
  </Toolbar>
);

EmptyMessageBase.propTypes = {
  getMessage: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
};

export const EmptyMessage = withStyles(styles, { name: 'EmptyMessage' })(EmptyMessageBase);
